import { render, staticRenderFns } from "./SettingItem.vue?vue&type=template&id=7ae4d22c"
import script from "./SettingItem.vue?vue&type=script&lang=js"
export * from "./SettingItem.vue?vue&type=script&lang=js"
import style0 from "./SettingItem.vue?vue&type=style&index=0&id=7ae4d22c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports